import { render, staticRenderFns } from "./Sentences.vue?vue&type=template&id=5a780d03&scoped=true&"
import script from "./Sentences.vue?vue&type=script&lang=js&"
export * from "./Sentences.vue?vue&type=script&lang=js&"
import style0 from "./Sentences.vue?vue&type=style&index=0&id=5a780d03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a780d03",
  null
  
)

export default component.exports